import { http, httpFile } from './http_service';

//Get all
export function all(){
    return http().get('/other-loan');
}
//Get all active
export function allActive(){
    return http().get('/other-loan/active');
}
//Get Single
export function single(id){
    return http().get(`/other-loan/${id}`);
}
//Add one
export function add(data){
    return http().post('/other-loan', data)
}
//Update
export function update(id, data){
    return http().put(`/other-loan/${id}`, data)
}
//Delete one
export function deleteSingle(id){
    return http().delete(`/other-loan/${id}`);
}